import React, { useState } from "react";

function FaqComponent() {
  const [openIndex, setOpenIndex] = useState(-1);

  const toggleItem = (index) => {
    if (openIndex === index) {
      setOpenIndex(-1);
    } else {
      setOpenIndex(index);
    }
  };

  const faqData = [
    {
      question: "What is EasyGST Software all about?",
      answer:
        "EasyGST software Developed by Electrocom Software Pvt. Ltd., simplifies GST return e-filing by automating the process and ensuring accuracy. It enables the filing of GSTR-1, GSTR-3B, GSTR-9/9C, and reconciles GSTR-2A/2B data with accounts data. EasyGST software provides a user-friendly and efficient platform for Tax Professionals & businesses to manage their GST compliance requirements.",
    },
    {
      question:
        " Why EasyGST is the first choice of CA’s and Tax Professionals?",
      answer:
        " EasyGST is the first choice of CA and tax professionals because it has a user-friendly interface and simplifies the GST compliance process. The software simplifies the GST compliance process, making it easier for professionals to manage client data and file various returns accurately. The software is easy to use, even for those with limited technical expertise, making it a top choice for professionals.",
    },
    {
      question: "Can I file the QRMP scheme (IFF return) using EasyGST?",
      answer:
        "Yes, you can file the IFF (Invoice Furnishing Facility) return under the QRMP (Quarterly Return Monthly Payment) scheme using EasyGST software. The software is designed to streamline GST compliance and includes features to facilitate the filing of various GST returns, including the IFF return.",
    },
    {
      question:
        "Is annual & Audit return filing facility in GST filing software?",
      answer:
        "EasyGST software provides facilities for filing annual returns and conducting audits as per GST compliance requirements. With India’s best GST Software - EasyGST, businesses can easily file GSTR-9 and GSTR-9C returns, which are annual return forms.",
    },
    {
      question: "Is there an invoicing facility in EasyGST software?",
      answer:
        "EasyGST software includes an invoicing feature that allows businesses to create professional and customized invoices easily. The software enables businesses to create GST-compliant invoices that include all necessary details such as HSN codes, item descriptions, and tax rates.",
    },
  ];

  return (
    <>
      <div id="FAQ" className="sm:flex sm:py-20 py-12 px-5 sm:px-9 bg-[#f1f5f8] relative justify-center items-center">
        <div className="w-full max-w-7xl">
          <div className="bg-white border-2 rounded-2xl shadow-xl sm:px-12 pb-10">
            <div className="flex flex-col items-center">
              <h2 className="font-bold text-5xl mt-5 tracking-tight">
                FA<span className="text-[#519980]">Q</span>
              </h2>
              <p className="text-neutral-500 text-xl mt-2">
                Frequently asked questions
              </p>
            </div>
            <div className="grid px-1 sm:px-0 divide-y divide-neutral-200 w-full mx-auto mt-8">
              {faqData.map((faq, index) => (
                <div className="py-5" key={index}>
                  <details
                    className={`group ${openIndex === index ? "open" : ""}`}
                    open={openIndex === index}
                  >
                    <summary
                      className="flex justify-between  text-xl items-center font-medium cursor-pointer list-none"
                      onClick={() => toggleItem(index)}
                    >
                      <span className="px-4">{faq.question}</span>
                      <span className="transition bg-[#7decc6] mx-4 rounded-full group-open:rotate-180">
                        <svg
                          fill="none"
                          height="24"
                          shapeRendering="geometricPrecision"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          viewBox="0 0 24 24"
                          width="24"
                        >
                          <path d="M6 9l6 6 6-6"></path>
                        </svg>
                      </span>
                    </summary>
                    <p
                      className={`text-gray-800 text-lg px-5 mt-3 ${
                        openIndex === index ? "fadeIn" : ""
                      }`}
                    >
                      {faq.answer}
                    </p>
                  </details>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* <div className="sm:w-1/2 mt-10 sm:mt-0 px-5">
          <div className="text-center pb-6">
            <p className="mb-2 text-4xl text-black font-extrabold">
              A Word from our <span className="text-[#7decc6]">Customers</span>
            </p>
            <p className="mb-0 text-lg">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Necessitatibus, iusto?
            </p>
          </div>
          <Review />
        </div> */}
      </div>
    </>
  );
}

export default FaqComponent;
